"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var Phone = function Phone(_ref) {
  var name = _ref.name,
    fill = _ref.fill,
    className = _ref.className,
    title = _ref.title;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    className: "icon icon-no-fill ".concat(className),
    xmlns: "http://www.w3.org/2000/svg",
    version: "1.1",
    viewBox: "0 0 24 24",
    height: "24",
    width: "24"
  }, /*#__PURE__*/_react["default"].createElement("title", null, title || name), /*#__PURE__*/_react["default"].createElement("g", {
    transform: "matrix(1,0,0,1,0,0)",
    stroke: fill,
    fill: "none",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M 15.04,22.39l0.012,0.007c2.188,1.393,5.05,1.079,6.884-0.755l0.774-0.774c0.72-0.721,0.72-1.888,0-2.609 L19.449,15c-0.721-0.72-1.888-0.72-2.609,0l0,0c-0.719,0.72-1.886,0.721-2.606,0.002c-0.001-0.001-0.001-0.001-0.002-0.002 L9.014,9.781c-0.72-0.721-0.72-1.888,0-2.609l0,0c0.72-0.719,0.721-1.886,0.002-2.606C9.015,4.565,9.015,4.565,9.014,4.564 L5.754,1.3c-0.721-0.72-1.888-0.72-2.609,0L2.371,2.074C0.537,3.908,0.223,6.77,1.615,8.958L1.623,8.97 C5.196,14.26,9.751,18.815,15.04,22.39z"
  })));
};
Phone.propTypes = {
  name: _propTypes["default"].string.isRequired,
  title: _propTypes["default"].string,
  fill: _propTypes["default"].string,
  className: _propTypes["default"].string
};
Phone.defaultProps = {
  fill: '#ffffff',
  className: ''
};
var _default = exports["default"] = Phone;